var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 8v1.6h8V8c0-2.21-1.79-4-4-4s-4 1.79-4 4m-.8 2.4H5.6V28h20.8V10.4h-5.6v4.8H20v-4.8h-8v4.8h-.8zm0-.8V8a4.801 4.801 0 0 1 9.6 0v1.6h6.4v19.2H4.8V9.6z"
  })));
};
export default SvgCart;